import { Action } from '@ngrx/store';
import {DeviceSettingFilter, DeviceSettingList} from '../device-mgt.model';

export enum DeviceMgtListFilterActionTypes {
  LoadDeviceMgtListFilters = '[DeviceMgtListFilter] Load DeviceMgtListFilters',
  SelectedDeviceMgtListFilters = '[DeviceMgtListFilter] Select DeviceMgtListFilters'
}

export class LoadDeviceMgtListFilters implements Action {
  readonly type = DeviceMgtListFilterActionTypes.LoadDeviceMgtListFilters;
}

export class SelectDeviceMgtListFilters implements Action {
  readonly type = DeviceMgtListFilterActionTypes.SelectedDeviceMgtListFilters;
  constructor(public payload: DeviceSettingFilter) {}
}

export type DeviceMgtListFilterActions = LoadDeviceMgtListFilters
  | SelectDeviceMgtListFilters;
